import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { customTextColor } from "../../../utils/const";
import styles from "../InternalTracker.module.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  addCommentsNotes,
  deleteCommentsNotes,
  getTrackerNotes,
  updateTrackerNotes,
} from "../../../redux/internal-tracking/InternalTrackerSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { PiTrashLight } from "react-icons/pi";
import { Icon } from "@iconify/react/dist/iconify.js";

const defaultmassage = [
  {
    label: "This candidate isn’t response phone & email.",
    value: "This candidate isn’t response phone & email. ",
  },
  {
    label: "This candidate isn’t available in job market. ",
    value: "This candidate isn’t available in job market.  ",
  },
  {
    label: "Expected rate isn’t matching with profile rate.",
    value: "Expected rate isn’t matching with profile rate. ",
  },
  {
    label: "Candidate skills aren’t matching with resume.",
    value: "Candidate skills aren’t matching with resume. ",
  },
  {
    label: "Add new comment",
    value: "Add new comment",
  },
];
function InternalTrackerCommentDrawer({ handleClose, show, candidateDetails }) {
  const [open, setOpen] = useState(false);
  const [reviewID, setReviwID] = useState(0);
  const dispatch = useDispatch();
  const notesDetails = useSelector((state) => state.tracker.gitMotesDetails);
  const candidateNotesStatus = useSelector(
    (state) => state.tracker.candidateNotesStatus
  );

  const formik = useFormik({
    initialValues: {
      question: "",
      add_question: "",
    },
    validationSchema: Yup.object().shape({
      question: Yup.string().required("At least select one question"),

      // add_question: Yup.string().when("question", (question, schema) => {
      //   return question === "Add new comment"
      //     ? schema.required("Comments Add is required")
      //     : schema.notRequired();
      // }),
      add_question: Yup.string().when("question", (question, schema) => {
        console.log({ question, schema });
        if (question[0] === "Add new comment") {
          return schema.required("Add Question is required");
        }
        return schema; // Keep the default schema (not required)
      }),
    }),
    onSubmit: (values) => {
      let userData;
      if (values?.question === "Add new comment") {
        userData = {
          candidate_tracker: candidateDetails?.data?.id,
          comment: values?.add_question,
        };
      } else {
        userData = {
          candidate_tracker: candidateDetails?.data?.id,
          comment: values?.question,
        };
      }

      dispatch(addCommentsNotes(userData));
    },
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    let ID = candidateDetails?.data?.id;
    dispatch(getTrackerNotes(ID));
  }, [candidateDetails]);

  const handleAddQuestionChange = (event) => {
    const { value } = event.target;
    if (/^[a-zA-Z\s]*$/.test(value)) {
      formik.setFieldValue("add_question", value);
    }
  };

  const handleOnClickYesOrNo = (tracker_review, jujmentStatus) => {
    let ID = candidateDetails?.data?.id;
    let userData = {
      tracker_review: tracker_review,
      status: jujmentStatus,
    };
    dispatch(updateTrackerNotes({ userData, ID }));
  };

  const handleOnClickDeleteNote = () => {
    let ID = candidateDetails?.data?.id;
    let userData = {
      review_id: reviewID,
    };
    dispatch(deleteCommentsNotes({ ID, userData }));
  };

  const handleOnClickDelete = (id) => {
    console.log({ id });

    setReviwID(id);
    handleClickOpen();
  };

  useEffect(() => {
    let ID = candidateDetails?.data?.id;
    if (
      candidateNotesStatus === "update_tracker_note_succeeded" ||
      candidateNotesStatus === "create_tracker_note_succeeded"
    ) {
      dispatch(getTrackerNotes(ID));
      formik.resetForm({
        values: {
          add_question: "",
          question: "",
        },
      });
    }
  }, [candidateDetails, candidateNotesStatus]);

  useEffect(() => {
    let ID = candidateDetails?.data?.id;
    if (candidateNotesStatus === "delete_tracker_note_succeeded") {
      dispatch(getTrackerNotes(ID));
      handleCloseModal();
    }
  }, [candidateDetails, candidateNotesStatus]);

  const reviewComments = notesDetails?.data?.map((item) =>
    item?.review_comment?.trim()
  );

  const filteredMessages = defaultmassage.filter(
    (message) => !reviewComments?.includes(message?.value?.trim())
  );

  console.log({ filteredMessages });

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "40%",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Offcanvas.Title style={{ fontWeight: "600", color: customTextColor }}>
          Existing note on the {candidateDetails?.data?.full_name} - Profile
        </Offcanvas.Title>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
          {notesDetails?.data?.length > 0 &&
            notesDetails?.data?.map((view) => {
              return (
                <Grid container sx={{ marginBottom: "17px" }}>
                  <Grid item xs={12} sm={12} md={7} lg={7}>
                    <span>
                      <Typography>
                        <b>{view?.review_comment}</b>
                      </Typography>
                      <Typography>
                        Last Note 27th March 2025, 10:30 PM
                      </Typography>
                    </span>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    lg={4}
                    sx={{
                      color: customTextColor,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "baseline",
                    }}
                  >
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        sx={{
                          // textDecoration: "underline",
                          marginRight: "5px",
                          cursor: "pointer",
                          color: "#66cf96",
                          border: "1px solid #66cf96",
                          backgroundColor: view?.current_user_has_status
                            ? "#66cf96"
                            : "",
                          padding: "3px 10px",
                          borderRadius: "5px",
                        }}
                        onClick={() => handleOnClickYesOrNo(view?.id, 1)}
                        disabled={candidateNotesStatus === "loading"}
                      >
                        <b>
                          <b>
                            {candidateNotesStatus === "loading" &&
                            view?.id === reviewID
                              ? "Loading"
                              : "Yes"}
                          </b>
                        </b>
                      </Typography>
                      <b> ({view?.total_yes_count})</b>
                    </span>
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        sx={{
                          marginRight: "5px",
                          cursor: "pointer",
                          border: "1px solid #FF7171",
                          backgroundColor: view?.current_user_has_status
                            ? "#FF7171"
                            : "",
                          color: "#FF7171",
                          padding: "3px 10px",
                          borderRadius: "5px",
                        }}
                        onClick={() => handleOnClickYesOrNo(view?.id, 2)}
                        disabled={candidateNotesStatus === "loading"}
                      >
                        <b>
                          {candidateNotesStatus === "loading" &&
                          view?.id === reviewID
                            ? "Loading"
                            : "No"}
                        </b>
                      </Typography>
                      <b> ({view?.total_no_count})</b>
                    </span>
                  </Grid>
                  {view?.current_user_has_comment && (
                    <Grid item xs={12} sm={12} md={1} lg={1}>
                      <Icon icon="mynaui:trash" height={22} width={22}   
                      style={{
                        color: "red",
                        // fontSize: "22px",
                        marginLeft: "10px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleOnClickDelete(view?.id)}
                      />
                      {/* <PiTrashLight
                        style={{
                          color: "red",
                          fontSize: "22px",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleOnClickDelete(view?.id)}
                      /> */}
                    </Grid>
                  )}
                </Grid>
              );
            })}

          {/* <Grid container>
            <Grid item xs={12} sm={12} md={9} lg={9}>
              <span>
                <Typography>
                  <b> This candidate isn’t response phone & email.</b>
                </Typography>
                <Typography>Last Note 27th March 2025, 10:30 PM</Typography>
              </span>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              sx={{
                color: customTextColor,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
              }}
            >
              <span style={{ display: "flex", alignItems: "center" }}>
                <Typography
                  sx={{
                    textDecoration: "underline",
                    marginRight: "5px",
                    cursor: "pointer",
                  }}
                >
                  <b>Yes </b>
                </Typography>
                <b> (57%)</b>
              </span>
              <span style={{ display: "flex", alignItems: "center" }}>
                <Typography
                  sx={{
                    textDecoration: "underline",
                    marginRight: "5px",
                    cursor: "pointer",
                  }}
                >
                  <b>No</b>
                </Typography>
                <b> (50%)</b>
              </span>
            </Grid>
          </Grid> */}
        </Box>
        <form onSubmit={formik.handleSubmit}>
          {formik?.values?.question !== "Add new comment" && (
            <Box sx={{ width: "100%", marginTop: "50px" }}>
              <TextField
                select
                label="Select Your Question"
                variant="standard"
                name="question"
                sx={{ width: "100%" }}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.question}
              >
                {filteredMessages.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              {formik.touched.question && formik.errors.question ? (
                <div className={styles.error}>{formik.errors.question}</div>
              ) : null}
            </Box>
          )}

          {formik?.values?.question === "Add new comment" && (
            <Box sx={{ width: "100%", marginTop: "30px" }}>
              <TextField
                label="Add new Comment"
                variant="standard"
                name="add_question"
                onChange={handleAddQuestionChange}
                onBlur={formik.handleBlur}
                value={formik.values.add_question}
                sx={{ width: "100%" }}
              />
              {formik.touched.add_question && formik.errors.add_question ? (
                <div className={styles.error}>{formik.errors.add_question}</div>
              ) : null}
            </Box>
          )}
        </form>
        <Box sx={{ marginTop: "20px" }}>
          <button
            style={{
              cursor: "pointer",
              padding: "8px 20px",
              backgroundColor: "#2d73b5",
              color: "#fff",
              borderRadius: "5px",
              border: "none",
            }}
            onClick={formik.handleSubmit}
            type="submit"
            disabled={candidateNotesStatus === "loading"}
          >
            {candidateNotesStatus === "loading" ? "Loading" : "Submit Note"}
          </button>
        </Box>
      </Offcanvas.Body>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleCloseModal}
        maxWidth="md"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center" }}
          >
            <b>Change Candidate Status </b>
          </DialogTitle>
          <DialogContent sx={{ textAlign: "center" }}>
            Are you sure you want to delete
          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button
                sx={{ border: "1px solid #2d73b5", color: "#2d73b5" }}
                onClick={handleOnClickDeleteNote}
                disabled={candidateNotesStatus === "loading"}
              >
                {candidateNotesStatus === "loading" ? "Loading" : "Yes"}
              </button>
              <button
                sx={{ color: "#97B6F1", border: "1px solid #2d73b5" }}
                onClick={handleCloseModal}
                disabled={candidateNotesStatus === "loading"}
              >
                No
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </Offcanvas>
  );
}

export default InternalTrackerCommentDrawer;
